import type { AdminDashboardData } from '@workspace/api-backend'
import { MetricCard } from '@workspace/ui/components/metric-card'
import { TimeSeriesChart } from '@workspace/ui/components/time-series-chart'
import { BreakdownList } from './breakdown-list'
import { DashboardCard, DashboardSection } from './dashboard-card'
import { formatPercent } from './dashboard-format'

const TIER_LABELS: Record<string, string> = {
  INVITED: 'Invited',
  PROMISING: 'Promising',
  OTHER: 'Other',
}

export function EvaluationsSection({ data }: { data: AdminDashboardData }) {
  const { evaluations } = data
  const pitchCompletionRate =
    evaluations.pitchSessions.total > 0
      ? evaluations.pitchSessions.completed / evaluations.pitchSessions.total
      : 0
  return (
    <DashboardSection title="Evaluations">
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <MetricCard label="Prescreens" value={evaluations.totals.prescreens.toLocaleString()} />
        <MetricCard
          label="Deep evaluations"
          value={evaluations.totals.deepEvaluations.toLocaleString()}
        />
        <MetricCard
          label="Pitch sessions"
          value={evaluations.pitchSessions.total.toLocaleString()}
          subtitle={`${formatPercent(pitchCompletionRate)} completed`}
        />
        <MetricCard
          label="Failed evaluations"
          value={evaluations.totals.failed.toLocaleString()}
          variant={evaluations.totals.failed > 0 ? 'warning' : 'default'}
        />
      </div>
      <div className="grid gap-4 lg:grid-cols-2">
        <DashboardCard title="Evaluations per day" subtitle="Completed evaluations">
          <TimeSeriesChart
            data={evaluations.byDay}
            stacked
            series={[
              { key: 'prescreens', label: 'Prescreens', color: 'var(--chart-1)' },
              { key: 'deepEvaluations', label: 'Deep evaluations', color: 'var(--chart-2)' },
            ]}
          />
        </DashboardCard>
        <DashboardCard title="Prescreen outcomes" subtitle="Tier distribution">
          <BreakdownList
            items={evaluations.prescreenTiers.map((t) => ({
              label: TIER_LABELS[t.status] ?? t.status,
              count: t.count,
            }))}
          />
        </DashboardCard>
      </div>
    </DashboardSection>
  )
}
